module.exports = __webpack_public_path__ + "img/customer_design_9.9ca4f34.webp";